<input
	payee-input
	[value]="value"
	(input)="change(input.value)"
	#input
	[placeholder]="placeholder"
>
<button payee-suffix payee-copy-button [input]="input"></button>